<template>
  <ais-index
    :search-store="searchStore"
    :query-parameters="{ distinct: true }"
    class="page"
  >
    <SearchHero @resetPageCount="resetCount"></SearchHero>
    <div class="columns is-desktop">
      <div class="column is-5-desktop">
        <Search
          @resetPageCount="resetCount"
          @loadless="loadLess"
          @lazyload="loadMore"
          :page="parseInt(parameters.page, 10)"
          @highlight="highlight"
          @dehighlight="dehighlight"
        ></Search>
      </div>
      <DirectoryMap ref="directorymap"></DirectoryMap>
    </div>
  </ais-index>
</template>

<script>
/* eslint-disable import/no-unresolved */
import Search from '@/components/Search.vue';
import SearchHero from '@/components/SearchHero.vue';
import DirectoryMap from '@/components/DirectoryMap.vue';
import { createFromAlgoliaCredentials } from 'vue-instantsearch';
import store from '@/store';

const searchStore = createFromAlgoliaCredentials(
  store.state.algolia_app_id,
  store.state.algolia_api_key,
);

export default {
  props: {
    parameters: {
      type: Object,
      default() {},
    },
  },
  data() {
    return {
      searchStore,
    };
  },
  computed: {
    index() {
      if (this.$route.params.directory) {
        return this.$store
          .state
          .directories[this.$route.params.directory.toLowerCase()]
          .algolia_index;
      }
      return '';
    },
    queryParameters() { return this.searchStore.queryParameters; },
  },
  methods: {
    loadMore() {
      this.searchStore.page += 1;
      this.resetPage();
    },
    loadLess() {
      this.searchStore.page -= 1;
      this.resetPage();
    },
    resetCount() {
      this.searchStore.page = 1;
      this.resetPage();
    },
    resetPage() {
      window.scrollTo(0, 0);
      // Remove all highlighted elements
      const allResults = document.querySelectorAll('.ais-results a.media');
      allResults.forEach(result => result.classList.remove('has-background-secondary-lighter'));
    },
    highlight(id) {
      this.$refs.directorymap.$refs.mapRef.$mapPromise.then((map) => {
        const marker = this.$store.state.markers[`m${id}`];
        if (marker) {
          marker.setZIndex(999);
          marker.info.open(map, marker);
        }
      });
    },
    dehighlight(id) {
      this.$refs.directorymap.$refs.mapRef.$mapPromise.then((map) => {
        const marker = this.$store.state.markers[`m${id}`];
        if (marker) {
          marker.setZIndex(1);
          marker.info.close(map, marker);
        }
      });
    },
    updateUri(params) {
      const query = params;
      delete query.index;
      delete query.highlightPostTag;
      delete query.highlightPreTag;
      delete query.hitsPerPage;
      delete query.maxValuesPerFacet;
      delete query.hierarchicalFacets;
      delete query.facets;
      delete query.distinct;

      if (query.query === '') delete query.query;

      this.$router.replace({
        name: 'directory',
        query,
      });
    },
  },
  watch: {
    queryParameters: {
      handler(query) {
        this.updateUri(query);
        document.querySelector('.searchBox').focus();
      },
      deep: true,
    },
    $route(newRoute, oldRoute) {
      if (oldRoute.path !== newRoute.path) this.searchStore.indexName = this.index;
    },
  },
  created() {
    if (this.$store.state.directories[this.$route.params.directory.toLowerCase()] === undefined) {
      this.$router.push('/404');
    }
    this.searchStore.indexName = this.index;
    this.searchStore.queryParameters = this.parameters;
  },
  components: {
    Search,
    SearchHero,
    DirectoryMap,
  },
};
</script>
